import { Drawing } from "./index";

const canvas = document.createElement("canvas");
const context = canvas.getContext("2d") as CanvasRenderingContext2D;
const transparent = "rgba(0, 0, 0, 0)";

export function toPng(
  drawing: Drawing,
  options?: {
    transparentFill?: "black" | "white";
    resolution?: number;
  }
): string {
  const pxPerPixel =
    options?.resolution === undefined ? 8 : options.resolution / Drawing.side;

  canvas.width = Drawing.side * pxPerPixel;
  canvas.height = Drawing.side * pxPerPixel;

  const blackFill =
    options?.transparentFill === "black" ? transparent : "black";
  const whiteFill =
    options?.transparentFill === "white" ? transparent : "white";

  for (let i = 0; i < Drawing.side * Drawing.side; i++) {
    const col = i % Drawing.side;
    const row = Math.floor(i / Drawing.side);
    context.fillStyle = drawing.pixels[i] ? blackFill : whiteFill;
    context.fillRect(
      col * pxPerPixel,
      row * pxPerPixel,
      pxPerPixel,
      pxPerPixel
    );
  }

  return canvas.toDataURL("image/png");
}
